module.exports = __webpack_public_path__ + "static/media/  (97).beae8906.jpg";